import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import { InsentiveInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import { InsentiveSchema } from "../../../Schemas/sales/incentive_schema";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { roundOffCost } from "../../../Components/Functions/amt.fun";
import GSTCalculator from "../../../Components/Functions/preGstCalulator";
import { FcBullish } from "react-icons/fc";

const AddIncentive = () => {
  const store = useSelector((store) => store.login.user);
  const [isDropdown, setIsDropdown] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [incentive, setIncentive] = useState(0);
  const navigate = useNavigate();
  const handelSubmit = (values) => {
    values = {
      ...values,
      generatedById: store.UserId,
      generatedBy: store.Name,
    };
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest("POST", "/incentive/createIncentive/", formData, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Revenue generated successfully!");
          navigate(`/revenue-management/`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  const handleInputChange = (e) => {
    let { value } = e.target;
    value = value.trim();
    if (value.length < 2) {
      setIsDropdown([]);
      setShow(false);
      setIsSearchLoading(false);
      return;
    }
    setIsSearchLoading(true);
    performRequest(
      "GET",
      `/leads_v2/getLeadForSell/?search=${encodeURIComponent(value)}`
    )
      .then((res) => {
        if (res.status === 200) {
          setIsDropdown(res.data?.leads || []);
          setShow(true);
        } else {
          Toast("error", "Error while fetching leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setIsSearchLoading(false));
  };

  function startSearch(e) {
    if (e.target.value.trim().length == 10) {
      handleInputChange(e);
    }
  }
  const getPreGSTAmount = (total, gstPercent) => {
    if (!total || !gstPercent) return 0;

    const baseAmount = total / (1 + gstPercent / 100);
    return Number(baseAmount.toFixed(2)); // optional rounding
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcBullish className="fs-2  me-1" /> Revenue Management
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-md-3 col-sm-12 py-2">
                <div className="card p-2">
                  <h3>📋 Sales Incentive Policy</h3>
                  <hr className="m-0 mb-2" />
                  <ul>
                    <li>
                      💰 Monthly Revenue ≥ ₹2,00,000 →{" "}
                      <strong>1% Incentive</strong>
                    </li>
                    <li>
                      💰 Monthly Revenue &lt; ₹2,00,000 →{" "}
                      <strong>0.25% Incentive</strong>
                    </li>

                    <li>
                      📊 Project Value &gt; ₹50,00,000 →{" "}
                      <strong>0.35% Incentive</strong>
                    </li>
                    <li>
                      📊 Project Value ≤ ₹50,00,000 →{" "}
                      <strong>0.50% Incentive</strong>
                    </li>
                    <li>
                      👨‍💼 If the <strong>Lead</strong> closes the construction,
                      the Lead receives <strong>100%</strong> of the incentive.
                    </li>
                    <li>
                      🤝 If an <strong>Executive</strong> closes the
                      construction, the Executive receives <strong>70%</strong>{" "}
                      and the Lead receives <strong>30%</strong>.
                    </li>

                    <li>
                      📅 Monthly incentives are paid in the{" "}
                      <strong>next payroll cycle</strong>.
                    </li>
                    <li>
                      ✅ Construction incentives are paid in the{" "}
                      <strong>
                        next payroll only after full project completion
                      </strong>
                      .
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-9 col-sm-12 py-2">
                <div className="card">
                  <GSTCalculator />
                  <div className="card-header">
                    <h2 className="page-title">Add Sell</h2>
                  </div>
                  <Formik
                    initialValues={InsentiveInfo}
                    validationSchema={InsentiveSchema}
                    onSubmit={handelSubmit}
                    enableReinitialize={true}
                  >
                    {(props) => (
                      <Form>
                        <div className="card-body">
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Select lead (by contact number)
                            </label>
                            <div className="w-10 0 col">
                              <CustomInput
                                type={"text"}
                                className="form-control"
                                onChange={(e) => {
                                  props.setFieldValue(
                                    "leadName",
                                    e.target.value
                                  );
                                  if (
                                    props.values.leadId ||
                                    props.values.contact_number ||
                                    props.values.lead_owner
                                  ) {
                                    props.setFieldValue("leadId", "");
                                    props.setFieldValue("contact_number", "");
                                    props.setFieldValue("lead_owner", "");
                                  }
                                  startSearch(e, props);
                                }}
                                name="leadName"
                              ></CustomInput>
                              {isSearchLoading ? (
                                <div className="p-1">Loading leads...</div>
                              ) : (
                                show && (
                                  <div
                                    style={{
                                      maxHeight: "300px",
                                      overflow: "scroll",
                                    }}
                                  >
                                    {isDropdown && isDropdown.length > 0 ? (
                                      isDropdown.map((lead) => (
                                        <span
                                          key={lead.id}
                                          onClick={() => {
                                            props.setFieldValue(
                                              "leadName",
                                              lead.full_name
                                            );
                                            props.setFieldValue(
                                              "contact_number",
                                              lead.contact_number
                                            );
                                            props.setFieldValue(
                                              "lead_owner",
                                              lead.reAssignTo
                                            );
                                            props.setFieldValue(
                                              "leadId",
                                              lead.id
                                            );
                                            setIsDropdown([]);
                                            setShow(false);
                                          }}
                                          className="card p-1 cursor-pointer"
                                        >
                                          {lead.full_name}
                                        </span>
                                      ))
                                    ) : (
                                      <span className="p-1">
                                        No lead found with this name
                                      </span>
                                    )}
                                  </div>
                                )
                              )}
                              {props.touched.leadName &&
                                props.errors.leadName && (
                                  <p className="text-danger">
                                    {props.errors.leadName}
                                  </p>
                                )}
                              {props.touched.leadId && props.errors.leadId && (
                                <p className="text-danger">
                                  {props.errors.leadId}
                                </p>
                              )}
                              {!props.touched.leadId &&
                                !props.errors.leadId &&
                                props.touched.contact_number &&
                                props.errors.contact_number && (
                                  <p className="text-danger">
                                    {props.errors.contact_number}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Select Sells
                            </label>
                            <div className="w-100 col">
                              <CustomSelect
                                type="text"
                                name="sellsType"
                                onChange={(e) => {
                                  props.setFieldValue(
                                    "sellsType",
                                    e.target.value
                                  );
                                  props.setFieldValue("preGstAmount", 0);
                                  props.setFieldValue("incentiveAmount", 0);
                                }}
                              >
                                <option value="">Select</option>
                                {/* <option value="hydroponic masterclass">
                            Hydroponic Masterclass
                          </option> */}
                                <option value="practical training">
                                  Practical Training
                                </option>
                                <option value="physical site inspection">
                                  Physical Site Inspection
                                </option>
                                <option value="site inspection kit">
                                  Site Inspection Kit
                                </option>
                                <option value="aif project report">
                                  AIF Project Report
                                </option>
                                <option value="project conversion">
                                  Project Conversion
                                </option>
                                <option value="construction payment">
                                  Construction Payment
                                </option>
                                <option value="allother">
                                  All other sales excluding CEA and Hydroponics
                                </option>
                              </CustomSelect>

                              {props.touched.sellsType &&
                                props.errors.sellsType && (
                                  <p className="text-danger">
                                    {props.errors.sellsType}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Payment Mode
                            </label>
                            <div className="w-100 col">
                              <CustomSelect name="paymentMode">
                                <option value="">Select</option>
                                <option value="cash">Cash</option>
                                <option value="cheque">Cheque</option>
                                <option value="upi">UPI</option>
                                <option value="imps">IMPS</option>
                                <option value="rtgs">RTGS</option>
                                <option value="nft">NFT</option>
                              </CustomSelect>

                              {props.touched.paymentMode &&
                                props.errors.paymentMode && (
                                  <p className="text-danger">
                                    {props.errors.paymentMode}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Payment Date
                            </label>
                            <div className="w-100 col">
                              <CustomInput type="date" name="paymentDate" />

                              {props.touched.paymentDate &&
                                props.errors.paymentDate && (
                                  <p className="text-danger">
                                    {props.errors.paymentDate}
                                  </p>
                                )}
                            </div>
                          </div>
                          {props.values.sellsType !==
                            "physical site inspection" && (
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Amount Received
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="postGstAmount"
                                  onChange={(e) => {
                                    let amt = e.target.value;
                                    let preGst = getPreGSTAmount(amt, 18);
                                    if (
                                      preGst > 10000 &&
                                      props.values.sellsType ===
                                        "physical site inspection"
                                    ) {
                                      preGst = 10000;
                                    }
                                    props.setFieldValue("preGstAmount", preGst);

                                    props.setFieldValue(
                                      "incentiveAmount",
                                      preGst * 0.0025
                                    );
                                  }}
                                />
                                {props.touched.preGstAmount &&
                                  props.errors.preGstAmount && (
                                    <p className="text-danger">
                                      {props.errors.preGstAmount}
                                    </p>
                                  )}
                                <p className="text-muted">
                                  Amount mentioned here should be reflected in
                                  KBPL bank account.
                                </p>
                              </div>
                            </div>
                          )}
                          {props.values.sellsType ===
                            "physical site inspection" && (
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Recived SI Amount
                              </label>
                              <div className="w-100 col">
                                <CustomInput
                                  name="actualSIAmount"
                                  onChange={(e) => {
                                    let amt = e.target.value;
                                    let preGst = getPreGSTAmount(amt, 18);
                                    if (
                                      preGst > 10000 &&
                                      props.values.sellsType ===
                                        "physical site inspection"
                                    ) {
                                      preGst = 10000;
                                    }
                                    props.setFieldValue("preGstAmount", preGst);
                                    props.setFieldValue("actualSIAmount", amt);

                                    props.setFieldValue(
                                      "incentiveAmount",
                                      preGst * 0.0025
                                    );
                                  }}
                                />
                                {props.touched.actualSIAmount &&
                                  props.errors.actualSIAmount && (
                                    <p className="text-danger">
                                      {props.errors.actualSIAmount}
                                    </p>
                                  )}
                                <p className="text-muted">
                                  Amount mentioned here should be reflected in
                                  KBPL bank account.
                                </p>
                              </div>
                            </div>
                          )}
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Pre gst amount
                            </label>
                            <div className="w-100 col">
                              <p>
                                {roundOffCost(props.values.preGstAmount || 0)}
                              </p>
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Your incentive
                            </label>
                            <div className="w-100 col">
                              <p>
                                {roundOffCost(
                                  props.values.incentiveAmount || 0
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label
                              className={
                                props.values.paymentMode !== "cash"
                                  ? "w-25 form-label col-3 required"
                                  : "w-25 form-label col-3"
                              }
                            >
                              Upload Payment Receipt
                            </label>
                            <div className="w-100 col">
                              <CustomInput
                                name="paymentReceipt"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "paymentReceipt",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {props.touched.paymentReceipt &&
                                props.errors.paymentReceipt && (
                                  <p className="text-danger">
                                    {props.errors.paymentReceipt}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Sell description
                            </label>
                            <div className="w-100 col">
                              <CustomTextArea
                                name="incentiveDescription"
                                rows={5}
                              />
                              {props.touched.incentiveDescription &&
                                props.errors.incentiveDescription && (
                                  <p className="text-danger">
                                    {props.errors.incentiveDescription}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="btn-list justify-content-end">
                            <FormSubmitButton buttonText="Create Sell" />
                            <SimpleButton
                              buttonText="Cancel"
                              type="secondary"
                            />
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default AddIncentive;
